import type { Job } from "~/db/types";
const { convert } = require("html-to-text");

export const buildShareContent = (job: Job) => {
  return encodeURIComponent(
    `${job.title} in ${job.location} ${
      job.schoolName ? "with " + job.schoolName : ""
    } ${window.location.origin}/job/${job.id} #schooljobs #teachingjobs`
  );
};

export const buildTelegramShareContent = (job: Job) => {
  const jobDescriptionPoints = convert(job.shortDescription)
    .split(/\r?\n|\r|\n/g)
    .filter((el: string) => el !== "")
    .map((el: string) => "👉 " + el.trim())
    .join("\n\n");

  const textContent = `🔴  SCHOOLJOBS.LIVE OPENINGS  🔴 

India's 1st Privacy Focused Job Portal Dedicated For Educational Institutions.

👀 Looking for ${job.title?.trim()} 👀

📍 ${job.location?.trim()}  
🏫 ${job.schoolName?.trim()}
💸 ₹ ${
    job.salary?.split("-")[0] === "0" || job.salary === ""
      ? "Salary Negotiable"
      : job.salary
  }

📝 Job Description:

 ${jobDescriptionPoints}

 ▀▄▀▄▀▄ EASY APPLY 👇🏻 ▄▀▄▀▄▀

           ${window.location.origin}/job/${job.id} 

`;

  return encodeURIComponent(textContent);
};

export const buildWhatsAppShareContent = (job: Job) => {
  const jobDescriptionPoints = convert(job.shortDescription)
    .split(/\r?\n|\r|\n/g)
    .filter((el: string) => el !== "")
    .map((el: string) => "👉 " + el.trim())
    .join("\n\n");

  const textContent = `🔴   *SCHOOLJOBS.LIVE OPENINGS*   🔴 

_India's 1st Privacy Focused Job Portal Dedicated For Educational Institutions._

👀 Looking for _*${job.title?.trim()}*_ 👀

📍 *${job.location?.trim()}*  
🏫 *${job.schoolName?.trim()}*
💸 *₹ ${
    job.salary?.split("-")[0] === "0" || job.salary === ""
      ? "Salary Negotiable"
      : job.salary
  }*

📝 *Job Description*:

 ${jobDescriptionPoints}

 ▀▄▀▄▀▄ EASY APPLY 👇🏻 ▄▀▄▀▄▀

           ${window.location.origin}/job/${job.id} 

`;

  return encodeURIComponent(textContent);
};

export const buildShareURLTelegram = (job: Job) => {
  return `https://t.me/share/url?url=${window.location.origin}/job/${
    job.id
  }&text=${buildTelegramShareContent(job)}`;
};

export const buildShareURLTwitter = (job: Job) => {
  return `https://twitter.com/intent/tweet?text=${buildShareContent(job)}`;
};

export const buildShareURLWhatsApp = (job: Job) => {
  return `whatsapp://send?text=${buildWhatsAppShareContent(job)}`;
};

export const buildShareURLFaceBook = (job: Job) => {
  return window
    ? `http://www.facebook.com/sharer.php?u=${window.location.origin}/job/${job.id}`
    : ".";
};
